"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M15 2H5C4.448 2 4 2.448 4 3V8C4 8.552 4.448 9 5 9H10.5C10.707 9 10.824 8.765 10.701 8.6L9.2 6.6C8.869 6.158 8.958 5.531 9.4 5.2C9.843 4.869 10.469 4.958 10.8 5.4L13.8 9.4C13.812 9.417 13.813 9.436 13.824 9.452C13.847 9.486 13.867 9.52 13.885 9.557C13.907 9.599 13.922 9.642 13.937 9.688C13.951 9.729 13.965 9.769 13.974 9.811C13.981 9.852 13.983 9.891 13.986 9.933C13.988 9.956 14 9.976 14 10C14 10.024 13.988 10.044 13.986 10.067C13.983 10.109 13.981 10.148 13.974 10.189C13.965 10.231 13.951 10.271 13.937 10.312C13.922 10.357 13.907 10.401 13.885 10.443C13.867 10.48 13.847 10.514 13.824 10.548C13.813 10.564 13.812 10.583 13.8 10.6L10.8 14.6C10.604 14.862 10.303 15 9.999 15C9.791 15 9.58 14.935 9.4 14.8C8.958 14.469 8.869 13.842 9.2 13.4L10.701 11.4C10.824 11.235 10.707 11 10.5 11H5C4.448 11 4 11.448 4 12V17C4 17.552 4.448 18 5 18H15C15.552 18 16 17.552 16 17V3C16 2.448 15.552 2 15 2Z",
    fill: "#727B7F"
  }));
};